/**
 * Enum representing non-applicable policy documents for download.
 */
 export enum NonApplicablePolicyDocuments {
    CertificateOfCurrency = 'Certificate of Currency'
}